"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var orders_1 = require("../../api/orders");
var usePagedOptions_1 = require("../../hooks/usePagedOptions");
var paged_entity_dropdown_1 = require("./paged-entity-dropdown");
var CustomerDropdown = function (_a) {
    var _b;
    var label = _a.label, _c = _a.placeholder, placeholder = _c === void 0 ? "Search for a player" : _c, selected_user_ids = _a.selected_user_ids, on_selection_change = _a.on_selection_change, _d = _a.is_disabled, is_disabled = _d === void 0 ? false : _d;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _e = (0, usePagedOptions_1.usePagedOptions)(), queryArgs = _e.queryArgs, onSearch = _e.onSearch, onNextPage = _e.onNextPage, isFirstPage = _e.isFirstPage;
    // the summaries route requires the console user's id, exactly as the customer list sends it
    var _f = (0, orders_1.useGetCustomerOrderSummariesQuery)(__assign(__assign({}, queryArgs), { user_id: user === null || user === void 0 ? void 0 : user._id }), { skip: !(user === null || user === void 0 ? void 0 : user._id) }), data = _f.data, isFetching = _f.isFetching;
    var pageOptions = (0, react_1.useMemo)(function () {
        var _a;
        return ((_a = data === null || data === void 0 ? void 0 : data.user_list) !== null && _a !== void 0 ? _a : [])
            .filter(function (customer) { return customer._id; })
            .map(function (customer) { return ({ label: [customer.name, customer.surname].filter(Boolean).join(" ") || customer.email || customer._id, value: customer._id }); });
    }, [data]);
    var options = (0, usePagedOptions_1.useAccumulatedOptions)(pageOptions, isFirstPage);
    return ((0, jsx_runtime_1.jsx)(paged_entity_dropdown_1.PagedEntityDropdown, { label: label, placeholder: placeholder, options: options, hasMore: options.length < ((_b = data === null || data === void 0 ? void 0 : data.count) !== null && _b !== void 0 ? _b : 0), isLoading: isFetching, onSearch: onSearch, onLoadMore: onNextPage, selectedValues: selected_user_ids, onSelectionChange: on_selection_change, isDisabled: is_disabled }));
};
exports.CustomerDropdown = CustomerDropdown;
